/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CampaignAnalyticsAverageRevenue,
    CampaignAnalyticsAverageRevenueFromJSON,
    CampaignAnalyticsAverageRevenueFromJSONTyped,
    CampaignAnalyticsAverageRevenueToJSON,
} from './CampaignAnalyticsAverageRevenue';
import {
    CampaignAnalyticsTotalRevenue,
    CampaignAnalyticsTotalRevenueFromJSON,
    CampaignAnalyticsTotalRevenueFromJSONTyped,
    CampaignAnalyticsTotalRevenueToJSON,
} from './CampaignAnalyticsTotalRevenue';

/**
 * 
 * @export
 * @interface CampaignAnalytics
 */
export interface CampaignAnalytics {
    /**
     * The total number of recipients the campaign was sent to.
     * @type {number}
     * @memberof CampaignAnalytics
     */
    recipients: number;
    /**
     * The number of emails successfully delivered to the recipients.
     * @type {number}
     * @memberof CampaignAnalytics
     */
    delivered: number;
    /**
     * The number of opened emails delivered to the recipients.
     * @type {number}
     * @memberof CampaignAnalytics
     */
    opens: number;
    /**
     * The date and time when the email was last opened by a recipient.
     * @type {Date}
     * @memberof CampaignAnalytics
     */
    last_opened?: Date;
    /**
     * The number of unique recipients who clicked on a tracked link in the email.
     * @type {number}
     * @memberof CampaignAnalytics
     */
    unique_clicks: number;
    /**
     * The total number of clicks on all tracked links in the email, including multiple clicks by the same recipient.
     * @type {number}
     * @memberof CampaignAnalytics
     */
    total_clicks: number;
    /**
     * The date and time when a recipient last clicked on a tracjed link in the email.
     * @type {Date}
     * @memberof CampaignAnalytics
     */
    last_clicked?: Date;
    /**
     * The total number of bounces for this campaign.
     * @type {number}
     * @memberof CampaignAnalytics
     */
    total_bounces: number;
    /**
     * The number of hard bounces for this campaign. Hard bounces happen when an email can't be delivered. This can be caused by an invalid email address or an unexpected error during sending.
     * @type {number}
     * @memberof CampaignAnalytics
     */
    hard_bounces: number;
    /**
     * The number of soft bounces for this campaign. Soft bounces are recognized by the email server, but are returned to the sender for a variety of reasons. This can include issues like the mailbox being full or temporarily unavailable.
     * @type {number}
     * @memberof CampaignAnalytics
     */
    soft_bounces: number;
    /**
     * The number of abuse reports for this campaign. Abuse reports are generated when a recipient marks an email as spam in their email client.
     * @type {number}
     * @memberof CampaignAnalytics
     */
    abuse_reports: number;
    /**
     * The number of recipients who unsubscribed from further emails after receiving this campaign.
     * @type {number}
     * @memberof CampaignAnalytics
     */
    unsubscribes: number;
    /**
     * The number of orders placed by recipients as a result of this campaign. These orders are completed and paid for.
     * @type {number}
     * @memberof CampaignAnalytics
     */
    paid_orders: number;
    /**
     * The number of all orders created in response to this campaign.
     * @type {number}
     * @memberof CampaignAnalytics
     */
    total_orders: number;
    /**
     * The number of orders created unique to the contact in response to this campaign.
     * @type {number}
     * @memberof CampaignAnalytics
     */
    unique_paid_orders: number;
    /**
     * The number of all orders created unique to the contact in response to this campaign.
     * @type {number}
     * @memberof CampaignAnalytics
     */
    unique_orders: number;
    /**
     * 
     * @type {CampaignAnalyticsTotalRevenue}
     * @memberof CampaignAnalytics
     */
    total_revenue: CampaignAnalyticsTotalRevenue;
    /**
     * 
     * @type {CampaignAnalyticsAverageRevenue}
     * @memberof CampaignAnalytics
     */
    average_revenue: CampaignAnalyticsAverageRevenue;
}

export function CampaignAnalyticsFromJSON(json: any): CampaignAnalytics {
    return CampaignAnalyticsFromJSONTyped(json, false);
}

export function CampaignAnalyticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CampaignAnalytics {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recipients': json['recipients'],
        'delivered': json['delivered'],
        'opens': json['opens'],
        'last_opened': !exists(json, 'last_opened') ? undefined : (new Date(json['last_opened'])),
        'unique_clicks': json['unique_clicks'],
        'total_clicks': json['total_clicks'],
        'last_clicked': !exists(json, 'last_clicked') ? undefined : (new Date(json['last_clicked'])),
        'total_bounces': json['total_bounces'],
        'hard_bounces': json['hard_bounces'],
        'soft_bounces': json['soft_bounces'],
        'abuse_reports': json['abuse_reports'],
        'unsubscribes': json['unsubscribes'],
        'paid_orders': json['paid_orders'],
        'total_orders': json['total_orders'],
        'unique_paid_orders': json['unique_paid_orders'],
        'unique_orders': json['unique_orders'],
        'total_revenue': CampaignAnalyticsTotalRevenueFromJSON(json['total_revenue']),
        'average_revenue': CampaignAnalyticsAverageRevenueFromJSON(json['average_revenue']),
    };
}

export function CampaignAnalyticsToJSON(value?: CampaignAnalytics | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recipients': value.recipients,
        'delivered': value.delivered,
        'opens': value.opens,
        'last_opened': value.last_opened === undefined ? undefined : (value.last_opened.toISOString()),
        'unique_clicks': value.unique_clicks,
        'total_clicks': value.total_clicks,
        'last_clicked': value.last_clicked === undefined ? undefined : (value.last_clicked.toISOString()),
        'total_bounces': value.total_bounces,
        'hard_bounces': value.hard_bounces,
        'soft_bounces': value.soft_bounces,
        'abuse_reports': value.abuse_reports,
        'unsubscribes': value.unsubscribes,
        'paid_orders': value.paid_orders,
        'total_orders': value.total_orders,
        'unique_paid_orders': value.unique_paid_orders,
        'unique_orders': value.unique_orders,
        'total_revenue': CampaignAnalyticsTotalRevenueToJSON(value.total_revenue),
        'average_revenue': CampaignAnalyticsAverageRevenueToJSON(value.average_revenue),
    };
}

